import { normalizePermissionKey, normalizePermissionKeys } from '@/utils/permissionKeys';

/*
 * Rút lui `staff.*` — đã bỏ lớp tương thích coi `staff.manage` như bao hàm
 * staff.view/create/update/sync. Không còn gate nào trong ứng dụng hỏi key `staff.*`
 * (mọi decorator BE và mọi chỗ gác FE nay dùng `hrm.*`), nên nhánh đó là mã chết.
 */
export function hasRuntimePermission(permissions: readonly string[], key: string): boolean {
  const normalizedKey = normalizePermissionKey(key);
  const normalizedPermissions = normalizePermissionKeys(permissions);

  if (normalizedPermissions.includes('*') || normalizedPermissions.includes(normalizedKey)) return true;
  return normalizedPermissions.some((permission) =>
    permission.endsWith('.*') && normalizedKey.startsWith(permission.slice(0, -1)),
  );
}
